<template>
  <div class="app-wrapper"
       :class="langZh ? 'zh' : 'en'"
  >
    <top-nav class="nav"
             @changeLang="handleSelect"
    />
    <!--    <app-main class="main"/>-->
    <section class="app-main ">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key"/>
      </transition>
    </section>
    <CommonFooter v-show="isDesktop||isRowTablet" class="footer"></CommonFooter>
<!--    <mobileMenu v-else :menu-show="true" :is-footer-menu="true" class="mobile-menu"></mobileMenu>-->
  </div>
</template>

<script>
import topNav from './components/topNav'
import appMain from './components/appMain'
import CommonFooter from './components/CommonFooter'
import mobileMenu from "@/layout/components/topNav/mobileMenu";
import deviceMixin from '@/mixins/device'

export default {
  name: "Layout",
  mixins: [deviceMixin],

  data() {
    return {
      key: 0
    }
  },

  computed: {
    langZh() {
      return this.$i18n.locale === 'zh_CN'
    },
  },
  components: {
    topNav,
    appMain,
    CommonFooter,
    mobileMenu
  },
  methods: {
    handleSelect() {
      this.key++
    }
  }
}
</script>

<style lang="scss">
.zh {
  font-family: 'Alibaba-PuHuiTi', 'Alibaba-PuHuiTi-Medium';
}

.en *:not([class*="icon"]):not(.el-icon) {
  font-family: 'Arial' !important;
}

.app-wrapper {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  /*overflow: hidden;*/
  //display: flex;
  //flex-direction: column;

  //@media screen and (max-width: 1024px) {
  //  width: 100% !important;
  //}

}

.nav {
  /*height: 80px;*/

}

.main {
  /*min-height: calc(100vh - 400px - 56px - 17px - 80px);*/
  //flex: 1;
}

.footer {
}

.mobile-menu{
  width: 100%;
  height: fit-content;
  position:relative;
}
</style>
